import { Vector2, Vector3 } from '@babylonjs/core';

declare module '@babylonjs/core' {
  interface Vector2 {
    cosSimilarity(other: Vector2): number;
  }

  interface Vector3 {
    cosSimilarity(other: Vector3): number;
    angle(other: Vector3): number;
    signedAngle(other: Vector3, upAxis: Vector3): number;
  }
}
Vector2.prototype.cosSimilarity = function (other: Vector2) {
  return Vector2.Dot(this.normalize(), other.normalize());
};

Vector3.prototype.cosSimilarity = function (other: Vector3) {
  return Vector3.Dot(this.normalize(), other.normalize());
};

Vector3.prototype.angle = function (other: Vector3) {
  const dot = Vector3.Dot(this.normalize(), other.normalize());
  return Math.acos(Math.min(Math.max(dot, -1), 1));
};

Vector3.prototype.signedAngle = function (other: Vector3, upAxis: Vector3 = Vector3.Up()): number {
  // 두 벡터를 정규화
  const n1 = this.normalize();
  const n2 = other.normalize();

  // 내적으로 각도 계산
  const angle = Math.acos(Math.min(Math.max(Vector3.Dot(n1, n2), -1), 1));

  // 외적으로 회전 방향 결정
  const cross = Vector3.Cross(n1, n2);
  const sign = Math.sign(Vector3.Dot(cross, upAxis));

  return angle * sign;
};
